export const DRAFT_BOOTSTRAP_DATA_KEY = 'fleek-agent-draft:init';
export const ROUTE_NEW_DRAFT = '/drafts/new';

export type DraftBootstrapData = {
  fromApp?: string;
  mode: 'chat' | 'form';
  prompt?: string;
  timestamp: Date;
};

export const setBootstrapData = ({
  mode,
  fromApp,
  prompt,
  timestamp,
}: {
  mode: 'chat' | 'form';
  fromApp?: 'agents-ui' | 'website';
  prompt?: string;
  timestamp?: Date;
}) => {
  localStorage.setItem(
    DRAFT_BOOTSTRAP_DATA_KEY,
    JSON.stringify({
      fromApp: fromApp ?? 'unknown',
      prompt,
      mode,
      timestamp: timestamp ?? Date.now(),
    }),
  );
};

export const getBootstrapData = (): DraftBootstrapData | undefined => {
  const raw = localStorage.getItem(DRAFT_BOOTSTRAP_DATA_KEY);
  if (!raw) return;
  return JSON.parse(raw);
};

export const clearBootstrapData = () => {
  localStorage.removeItem(DRAFT_BOOTSTRAP_DATA_KEY);
};
